export default __webpack_public_path__ + "static/media/faqs.b3a6233e.png";